<template>

  <v-container fluid>

    <v-row dense no-gutters>
      <v-col cols="12" class="pa-0" align="center">
        <v-btn style="width:94%;height:30px !important;" class="search_btn_freesize" elevation="0" outlined large @click="showpopup_com" >
          {{$t('emailtemp_title')}}
        </v-btn>
      </v-col>
    </v-row>   

    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" fullscreen>
        
        <v-card class="dialog_round pa-10">

          <v-card-title>
            <v-row justify="space-between">
              <v-col align="center" cols="6">
                <span class="dialog_title">{{$t('emailtemp_title')}}</span>
              </v-col>
              <v-col align="end" cols="6">
                <v-btn class="dialog_btn mr-10" rounded large @click="clear_com">{{$t('common_selectcancel')}}</v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-container fluid>

            <v-row align="start">
              <v-col class="pa-1">
                <!-- 테이블 -->
                <v-data-table
                  :headers="headers_com"
                  :items="itemList_com"
                  :no-data-text="$t('common_nodata')"
                  hide-default-footer
                  class="datatablestyle"
                  :items-per-page="pagerow_com"
                  item-key="IDX"
                  >
                  <template v-slot:header.ETEMP_TITLE>
                    <a :class="sort_name_com=='ETEMP_TITLE'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('ETEMP_TITLE')">{{$t("emailtemp_col1")}}</a>
                  </template>
                  <template v-slot:header.ETEMP_SENDER>
                    <a :class="sort_name_com=='ETEMP_SENDER'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('ETEMP_SENDER')">{{$t("emailtemp_col2")}}</a>
                  </template>
                  <template v-slot:header.ETEMP_LAN>
                    <a :class="sort_name_com=='ETEMP_LAN'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('ETEMP_LAN')">{{$t("emailtemp_col3")}}</a>
                  </template>
                  <template v-slot:header.REG_DATE_NAME>
                    <a :class="sort_name_com=='REG_DATE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('REG_DATE_NAME')">{{$t("emailtemp_col4")}}</a>
                  </template>
          
                  <template v-slot:item.ETEMP_LAN="{ item }">
                    <label>{{ item.ETEMP_LAN == 0 ? $t('emailtemp_col40') : $t('emailtemp_col41') }}</label>
                  </template>

                  <template v-slot:item.ETEMP_TITLE="{ item }">
                    <a @click="select_func(item)">{{item.ETEMP_TITLE}}</a>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>

            <!-- 하단 페이징 영역 -->
            <v-row>
              <v-col cols="12" md="12" class="d-flex justify-center">
                <v-btn v-if="bottompage_com > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
                <span v-for="n in subpage_com" :key="n.id">
                    <span v-if="page_com == bottompage_com-1+n">
                        <v-btn color="red" icon small @click="loadpage_com(bottompage_com-1+n)">{{bottompage_com-1+n}}</v-btn>
                    </span>
                    <span v-else>
                        <v-btn icon small @click="loadpage_com(bottompage_com-1+n)">{{bottompage_com-1+n}}</v-btn>
                    </span>
                </span>
                <v-btn v-if="subpage_com == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
              </v-col>
          </v-row>

          </v-container>
        </v-card-text>
        

        <v-card-actions>
          <v-row justify="center">
            <v-col cols="12" align="center">
              <v-btn class="dialog_cancel_btn" rounded large @click="close_com">{{$t("common_close")}}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-dialog>     
  </v-row>

  </v-container>
</template>

<script>
export default {

    //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
    props:{
        com_idx: Number,
        event_idx: Number,
    },

    data: () => ({
      
      dialog_com : false,
      load_flag : false,

      //필수 페이징 파라메터
      totalcnt_com : 0,       //전체 아이템 개수
      page_com : 0,
      maxpage_com : 0,        //전체 페이지 개수
      startpage_com : 1,      //시작 인덱스
      bottompage_com : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage_com : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수

      sort_name_com: 'REG_DATE',
      sort_type_com: true,    //true : DESC, false: ASC

      //테이블 정의
      headers_com: [
        {text: '템플릿명', value: 'ETEMP_TITLE', sortable: false, align:'center', width:'400px'},
        {text: '발송자', value: 'ETEMP_SENDER', sortable: false, align:'center', width:'180px'},
        {text: '언어', value: 'ETEMP_LAN', sortable: false, align:'center' , width:'120px'},
        {text: '등록일', value: 'REG_DATE_NAME', sortable: false, align:'center', width:'200px' },
      ],
      itemList_com: [],
      
      search_keyword_com : '',

      //한 페이지 ROW 개수 설정
      pagerow_com : 20,       //한 페이지에 보여줄 row수
      
    }),

    mounted(){
      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    updated(){
          
      if(this.dialog_com){
        if(!this.load_flag && this.itemList_com.length == 0 && this.search_keyword_com.length == 0){
          this.load_flag = true;
          this.loadpage_com(1);
        }
      }else{
        //팝업이 닫히면
        this.load_flag = false;
      }

    },    


    methods: {

      customsort_com(sortname){
        this.sort_name_com = sortname;
        this.sort_type_com = !this.sort_type_com;
        this.loadpage_com(this.page_com);
      },
      prev_com(){
          this.bottompage_com = this.bottompage_com - 10 >= 1 ? this.bottompage_com - 10 : 1;
          this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
          var temp_page = this.bottompage_com + this.subpage_com - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage_com(temp_page);
      },
      next_com(){
          this.bottompage_com = this.bottompage_com + 10 <= this.maxpage_com ? this.bottompage_com + 10 : this.maxpage_com;
          this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
          var temp_page = this.bottompage_com;
          this.loadpage_com(temp_page);
      },

      makepaging_com(){
          var div1 = this.totalcnt_com / this.pagerow_com; 
          var div2 = this.totalcnt_com % this.pagerow_com;
          if(div2 == 0){  
              this.maxpage_com = parseInt(div1);    
          }else{
              this.maxpage_com = parseInt(div1+1);
          }
          if(this.bottompage_com == 1){
            this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
          }
      },

      search_run_com(){
          this.loadpage_com(1);
      },

      loadpage_com(p){
          
          this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
          this.page_com = p;

          this.$http.post(this.$host+'/api/EmailTempList',{
                search_keyword: this.search_keyword_com == null || this.search_keyword_com == undefined ?  '' : escape(this.search_keyword_com)
              , sort_name:this.sort_name_com
              , sort_type: this.sort_type_com==true ? "DESC" : "ASC" 
              , page: this.page_com
              , pagerow: this.pagerow_com
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.com_idx
              , EVENT_IDX: this.event_idx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.load_flag = true;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.totalcnt_com = result.data.totalcnt;
              this.makepaging_com();
              const list = result.data.resultData;
              this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
              list.forEach(element => {
                  this.itemList_com.push(element); 
              });

            }else if(result.data.resultCode == 2){
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
            }

          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{

          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage_com(1);
      },      

      //검색
      search_run(){
        this.loadpage_com(1);
      },
      
      //다이얼로그 닫기
      close_com () {
          this.dialog_com = false
          this.select_com = [];
          this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
          this.search_keyword_com = '';
      },

      //선택취소
      clear_com(){
        this.$emit('cancelcallback', '')
        this.dialog_com = false
        this.select_com = [];
        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
        this.search_keyword_com = '';
      },      

      //추가 저장
      select_func(select_item) {
        this.$emit('callback', select_item);
        //콜백 호출 후 닫아야함.
        this.dialog_com = false
        this.select_com = [];
        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
        this.search_keyword_com = '';
      },      


      showpopup_com(){
          this.dialog_com = true;
          this.load_flag = false;
      },


    },
  
}
</script>


<style lang="css">
  td{
    height: 36px !important;
  }
</style>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>
  
  .v-input--selection-controls{
    margin-top:0px;
  }

</style>